function e(n) {
  return { name: "PHP template", subLanguage: "xml", contains: [{ begin: /<\?(php|=)?/, end: /\?>/, subLanguage: "php", contains: [{ begin: "/\\*", end: "\\*/", skip: !0 }, { begin: 'b"', end: '"', skip: !0 }, { begin: "b'", end: "'", skip: !0 }, n.inherit(n.APOS_STRING_MODE, { illegal: null, className: null, contains: null, skip: !0 }), n.inherit(n.QUOTE_STRING_MODE, { illegal: null, className: null, contains: null, skip: !0 })] }] };
}
export {
  e as default
};
